<script>
	import { Col, Row, Container } from 'sveltestrap';
</script>

<section class="section-sm bg-light">
	<Container>
		<Row>
			<Col md={4}>
				<div class="client-images my-3 my-md-0">
					<img src="images/svg/Logo_Consejo_Gris.svg" alt="logo-img" class="mx-auto img-fluid d-block" />
				</div>
			</Col>

			<Col md={4}>
				<div class="client-images my-3 my-md-0">
					<img src="images/svg/Logo_Conecta_Gris.svg" alt="logo-img" class="mx-auto img-fluid d-block" />
				</div>
			</Col>

			<Col md={4}>
				<div class="client-images my-3 my-md-0">
					<img src="images/svg/Logo_Consejo_Gris.svg" alt="logo-img" class="mx-auto img-fluid d-block" />
				</div>
			</Col>
		</Row>
	</Container>
</section>